import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';
import { NumberCell } from '../../../utils/Cells';

class BankRow extends Component {
    componentDidMount() {
        console.log(this.props)
    }

    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Sorszám</TableCell>
                            <TableCell>Tranzakció Azonosító</TableCell>
                            <TableCell>Tranzakció Típusa</TableCell>
                            <TableCell>Ellenoldali Számlaszám</TableCell>
                            <TableCell>Ellenoldali név</TableCell>
                            <TableCell>Közlemény</TableCell>
                            <TableCell>Összeg</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell> {this.props.row.publicId}</TableCell>
                            <TableCell>{this.props.row.transactionId}</TableCell>
                            <TableCell>{this.props.row.transactionTypeLabel}</TableCell>
                            <TableCell>{this.props.row.contraBankAccountNumber} </TableCell>
                            <TableCell>{this.props.row.contraName} </TableCell>
                            <TableCell>{this.props.row.comment} </TableCell>
                            <TableCell align="right"><NumberCell value={this.props.row.amount} /></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default BankRow;